var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bar"},[_c('div',{staticClass:"progress",style:({width: ((_vm.step/_vm.totalSteps*100) + "%")})})])}
var staticRenderFns = []

export { render, staticRenderFns }